// @ts-nocheck
import Breadcrumbs from 'atoms/breadcrumbs/breadcrumbs';
import Sheet from 'atoms/sheet/sheet';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import * as tableColumnSagaActions from 'models/tableColumns/sagaActions';
import * as tableColumnSelectors from 'models/tableColumns/selector';
import SideCar from 'molecules/sidecar/sidecar';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import CustomizeViewModal from 'organisms/CustomizeViewModal';
import ThetaDeleteModal from 'organisms/deleteModal/deleteModal';
import ExportGrid from 'organisms/exportGrid';
import ThetaMenu from 'organisms/thetaMenu/thetaMenu';
import UploadData from 'organisms/uploadData';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThetaGridPaginated from 'templates/thetaGridPaginated';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import * as constants from './constants';
import { isMasterDataStoresDelete, isMasterDataStoresWrite } from 'models/user/selector';
import GridActionBar from 'atoms/GridActionBar';
import GridCsvUpload from 'organisms/uploadData/gridCsvUpload';
import { isNewUploadEnabled } from 'models/user/selector';
import { fetchBookmarksList } from 'models/bookmarks/sagaActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { useColumnAliasName } from 'hooks/useColumnAliasName';
import { UPLOAD_MODEL_ID } from '../constants';
import { Button as AntButton, Tooltip } from 'antd';

const StoreMasterData: React.FunctionComponent = (props) => {
	const [openFilter, setOpenFilter] = React.useState<boolean>();
	const [isUploadEnabled, toggleUpload] = React.useState<boolean>(false);

	const getColumnAliasName = useColumnAliasName(UPLOAD_MODEL_ID);

	const breadcrumbs = props.breadcrumbs?.map((res) => ({
		...res,
		name: getColumnAliasName(res.name),
	}));

	const tableId = constants.TABLE_ID.toString();
	const dispatch = useDispatch();
	const [isDeleteModal, toggleDeleteModal] = React.useState(false);
	const hasWriteAccess = useSelector(isMasterDataStoresWrite);
	const hasDeleteAccess = useSelector(isMasterDataStoresDelete);
	const hasSearchFilters = useSelector((state) => dynamicGridSelectors.hasSearchFilters(state, constants.TABLE_ID));
	const gridMeta = useSelector((state) => dynamicGridSelectors.getGridMetadata(state, constants.TABLE_ID));

	const isCustomizeViewModalEnabled = useSelector((state) => tableColumnSelectors.isCustomizeViewModalEnabled(state));

	React.useEffect(() => {
		dispatch(dynamicGridSagaActions.erpEnabled({ tableId: constants.TABLE_ID }));
		dispatch(fetchBookmarksList({ tableId: constants.TABLE_ID }));
	}, [dispatch]);

	React.useEffect(() => {
		if (openFilter === undefined) {
			setOpenFilter(hasSearchFilters);
		}
	}, [hasSearchFilters]);

	const handleRefreshClick = React.useCallback(() => {
		dispatch(
			dynamicGridSagaActions.refreshGridData({
				tableId: constants.TABLE_ID,
			})
		);
	}, [tableId, dispatch]);

	const handleResetTableColumns = React.useCallback(async () => {
		dispatch(tableColumnSagaActions.resetTableColumnsAg(constants.TABLE_ID));
	}, [dispatch, tableId]);

	const customizeViewHandler = React.useCallback((isCustomizeViewModalEnabled: boolean) => {
		dispatch(tableColumnSagaActions.setCustomizeViewModal(isCustomizeViewModalEnabled));
	}, []);

	const selectedStores = useSelector((state) => dynamicGridSelectors.getTableSelection(state, constants.TABLE_ID));

	const handleBulkDeleteClick = () => {
		dispatch(
			dynamicGridSagaActions.handleBulkRowDelete({
				tableId: constants.TABLE_ID,
			})
		);
		toggleDeleteModal(false);
	};

	const deleteItems = () => {
		toggleDeleteModal(true);
	};

	const getDisabledStatus = React.useCallback(
		(option: any) => {
			switch (option.value) {
				case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
				case constants.MENU_ITEMS_VALUES.RESET_VIEW:
					return false;
				case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
					return !hasWriteAccess;
				case constants.MENU_ITEMS_VALUES.DELETE:
					return !hasDeleteAccess && !selectedStores?.selectedRowKeys?.length && !selectedStores?.isSelectAll;
				default:
					return true;
			}
		},
		[selectedStores]
	);

	const handleMenuItemClick = React.useCallback(
		(option: string) => {
			switch (option) {
				case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
					return customizeViewHandler(true);
				case constants.MENU_ITEMS_VALUES.RESET_VIEW:
					return handleResetTableColumns();
				case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
					return toggleUpload(true);
				case constants.MENU_ITEMS_VALUES.DELETE:
					return deleteItems();
				case constants.MENU_ITEMS_VALUES.EXPORT:
					return deleteItems();
				default:
					return;
			}
		},
		[handleResetTableColumns]
	);

	const hideCustomizeViewModal = React.useCallback(() => {
		customizeViewHandler(false);
	}, []);

	const uploadCloseClickHandler = React.useCallback(() => {
		toggleUpload(false);
	}, []);

	const gridConfig = {
		enableSelection: true,
		enableSorting: true,
		enableMultiSort: true,
		gridActions: hasDeleteAccess,
		selectionCallBack: () => {},
	};

	const templateConfig = {
		gridConfig,
		isFilterEnabled: openFilter === undefined ? false : openFilter,
		tableId: constants.TABLE_ID,

		dataProviderOptions: {
			type: 'POST',
			...REQUESTS.POST.GET_GRID_DETAILS_V2,
			pathParams: { tableId: 20 },
			version: 2,
		},
		selectRowKey: 'StoreID',
	};
	const isNewUpload = useSelector(isNewUploadEnabled);

	return (
		<React.Fragment>
			<Stack isVertical>
				<StackItem isStretch>
					<GridActionBar>
						<div className="content-head">
							<Stack gutter="medium" align="space-between">
								<div className="content-head-lt">
									<Breadcrumbs crumbs={breadcrumbs} />
								</div>
								<div className="content-head-rt">
									<Stack gutter="medium" className="action-btns">
										{isNewUpload && gridMeta?.UploadTableID && (
											<StackItem className="action-btn">
												<GridCsvUpload
													uploadTableId={gridMeta?.UploadTableID}
													parentTableId={tableId}
												/>
											</StackItem>
										)}
										<StackItem className="action-btn">
											<Tooltip title="Refresh">
												<AntButton
													className="menu-action--button"
													icon={
														<FontAwesomeIcon className="font-icon" icon={faArrowsRotate} />
													}
													onClick={handleRefreshClick}
												/>
											</Tooltip>
										</StackItem>
										<StackItem className="action-btn">
											<ExportGrid tableId={20} />
										</StackItem>
										<StackItem className="action-btn">
											<Tooltip title="More Options">
												{' '}
												<ThetaMenu
													type="3Dots"
													options={constants.MENU_ITEMS.filter(
														(x) => x.value !== 'CUSTOMIZE_VIEW'
													)}
													handleItemClick={handleMenuItemClick}
													isDisabled={getDisabledStatus}
												/>
											</Tooltip>
										</StackItem>
									</Stack>
								</div>
							</Stack>
						</div>
					</GridActionBar>
				</StackItem>
				<StackItem isStretch isGrow>
					<Sheet isPage className="order-tbl">
						<Stack isVertical gutter="medium">
							<StackItem isGrow isStretch>
								<ThetaGridPaginated config={templateConfig} />
							</StackItem>
						</Stack>
					</Sheet>
				</StackItem>
			</Stack>

			{isCustomizeViewModalEnabled && (
				<CustomizeViewModal hideModal={hideCustomizeViewModal} tableId={constants.TABLE_ID} />
			)}
			{isUploadEnabled && (
				<SideCar isActive={isUploadEnabled} handleOnClose={uploadCloseClickHandler}>
					<UploadData tableId={tableId} />
				</SideCar>
			)}
			{isDeleteModal && (
				<ThetaDeleteModal
					hideModal={() => {
						toggleDeleteModal(false);
					}}
					modalTitle={`Stores`}
					title={`(${
						selectedStores?.isSelectAll ? 'All' : selectedStores?.selectedRowKeys.length
					}) selected Store(s)`}
					handleDeleteClick={handleBulkDeleteClick}
					isLocked={true}
				/>
			)}
		</React.Fragment>
	);
};
export default StoreMasterData;
